import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { logOut } from "core/modules/auth/loginSlice";
import Menu from "./dropdownMenu";
import AvatarOrIcon from "helpers/components/AvatarOrIcon";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { AppBar, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import { IRoles } from "../types/types";
import { NavMenuButtons } from "./NavMenuButtons";
import { useStyles } from "../hooks/useStyles";
import { useAsonikaSelector } from "app/redux/hooks";

import { clearToken } from "helpers/TokenHelper";
import { apiUsers } from "app/axios";

const NavMenu = () => {
  const dispatch = useDispatch();
  const user = useAsonikaSelector((store) => store.user);
  const { t, i18n } = useTranslation("shared");
  const classes = useStyles();
  const [Roles, setRoles] = useState<IRoles>({} as IRoles);

  const logOutAction = useCallback(() => {
    dispatch(logOut());
    clearToken();
  }, [dispatch]);

  useEffect(() => {
    if (user.user.roles) {
      setRoles({
        User: user.user.roles.some((x: string) => x === "User"),
        Administrator: user.user.roles.some(
          (x: string) => x === "Administrator"
        ),
        CompanyAdministrator: user.user.roles.some(
          (x: string) => x === "CompanyAdministrator"
        ),
        Technologist: user.user.roles.some((x: string) => x === "Technologist"),
      });
    }
  }, [user]);

  useEffect(() => {
    (async () => {
      if (i18n.language !== user.user.language && user.user.id) {
        await apiUsers.setLocaleUser(user.user.id, {
          language: i18n.language,
        });
      }
    })();
  }, [user, i18n.language]);

  const selectLanguage = () => {
    if (i18n.languages[0] === "ru") {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("ru");
    }
  };

  return (
    <AppBar position="static" elevation={0}>
      <Toolbar className={classes.root}>
        <Link to={`/documents`} color="inherit" aria-label="menu">
          <img src={process.env.PUBLIC_URL + t("navmenu.logo")} alt="" />
        </Link>
        <Toolbar className={classes.navBar}>
          {user.isAuth && <NavMenuButtons Roles={Roles} />}
        </Toolbar>
        <button onClick={selectLanguage} className={classes.whiteButton}>
          {t("navmenu.language")}
        </button>
        {user.isAuth && (
          <>
            <Menu user={user} />
            <PopupState variant="popover">
              {(popupState) => (
                <div>
                  <button
                    {...bindTrigger(popupState)}
                    className={classes.userPopover}
                  >
                    <AvatarOrIcon
                      srcPath={user.img}
                      style={{ width: "2em", height: "2em" }}
                    />
                  </button>
                  <Popover
                    {...bindPopover(popupState)}
                    classes={{
                      paper: classes.paper_user,
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <Link to={`/profile`}>
                      <button className={classes.dropButton}>
                        {t("navmenu.profile")}
                      </button>
                    </Link>
                    <Link
                      to={`/`}
                      onClick={() => {
                        logOutAction();
                      }}
                    >
                      <button className={classes.dropButton}>
                        {t("navmenu.exit")}
                      </button>
                    </Link>
                  </Popover>
                </div>
              )}
            </PopupState>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};
export default NavMenu;
